/**
 * Created by odeds on 12/29/15.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var KEYS = {
        APIKEY: "key",
        APIKEY_SECRET: "apikey_secret",
        ACCESSTOKEN: "access_token",
        ACCESSTOKEN_SECRET: "access_token_secret",
        NAME: "name",
        DATE_CREATED: "date_created",
        ACTIVE: "active",
        DESCRIPTION: "description",
        HAS_IP_RESTRICTION: "has_ip_restriction"
    };

    var ApiKeyGalleryModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyGalleryModel = BaseModel.extend({
            idAttribute: KEYS.APIKEY,
            name: "ApiKeyGalleryModel",
            defaults: {
                description: "",
                active: true
            },

            _getValue: function (key) {
                return this.get(key);
            },

            isEditable: function(){
                return true;
            },
            isViewable: function(){
                return true;
            },

            hasIpRestrictionIcon: function(){
                return this._getValue(KEYS.HAS_IP_RESTRICTION);
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    ApiKeyGalleryModel.KEYS = KEYS;

    return ApiKeyGalleryModel;
});

